import { FormProvider, type UseFormReturn } from 'react-hook-form';
import IdentifyExperienceStepFields from './Components/IdentifyExperienceStepFields/IdentifyExperienceStepFields';
import IdentifyExperienceStepHeader from './Components/IdentifyExperienceStepHeader';
import IdentifyExperienceStepNavigation from './Components/IdentifyExperienceStepNavigation';
import type { IdentifyExperienceFormValues } from './IdentifyExperienceStep.schema';
import ProcessingState from '@/Models/ProcessingState';

export interface IdentifyExperienceStepFormProps {
    form: UseFormReturn<IdentifyExperienceFormValues>;
    activeStep: number;
    handleBack?: () => void;
    processingState: ProcessingState;
    experienceCriteriaProcessingState: ProcessingState;
    isEditMode: boolean;
    onSubmit: (values: IdentifyExperienceFormValues) => Promise<void>;
}

const IdentifyExperienceStepForm = ({
    form,
    activeStep,
    handleBack,
    processingState,
    experienceCriteriaProcessingState,
    isEditMode,
    onSubmit,
}: IdentifyExperienceStepFormProps) => {
    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col">
                <IdentifyExperienceStepHeader />
                <IdentifyExperienceStepFields
                    experienceCriteriaProcessingState={experienceCriteriaProcessingState}
                    isEditMode={isEditMode}
                />
                <IdentifyExperienceStepNavigation
                    activeStep={activeStep}
                    handleBack={handleBack}
                    processingState={processingState}
                    experienceCriteriaProcessingState={experienceCriteriaProcessingState}
                    isEditMode={isEditMode}
                />
            </form>
        </FormProvider>
    );
};

export default IdentifyExperienceStepForm;
